export default __webpack_public_path__ + "static/media/spark_69.c6a5f668.png";